import axios from 'axios';
import globalConfig from '../../../config/global.config';
import { SET_COMPARE_PRODUCTS, SET_COMPARE_PRODUCTS_FETCH } from '../actionTypes';

export function mergeProducts(products) {
  return {
    type: SET_COMPARE_PRODUCTS,
    products
  };
}

export function setProductsFetch(skus, isFetching) {
  return {
    type: SET_COMPARE_PRODUCTS_FETCH,
    skus,
    isFetching
  };
}

export function fetchProduct(sku) {
  return axios
    .get(`${globalConfig.rootUrl()}/products/${sku.toUpperCase()}`)
    .then(response => response.data)
    .catch(() => {
      return { sku: sku, isError: true };
    });
}

export function getProducts(skus) {
  return dispatch => {
    dispatch(setProductsFetch(skus, true));
    return Promise.all(skus.map(sku => fetchProduct(sku))).then(result => {
      return dispatch(mergeProducts(result));
    });
  };
}
